import Segment from 'src/app/modules/settings/model/segment-model';
import { Envelope } from './envelope';

export class EnvelopeEdit {
    id: number;
    expiration: Date;
    segmentId: number;
    segment: Segment;
    reminderFrequency: number;
}
